export default function TermsOfUse() {

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex flex-col items-start mb-6 border-b pb-4">
        <img src="/Logo-light.svg" alt="Logo" className="h-8 w-auto" />
        <br />
        <h1 className="text-2xl font-bold">Terms of Use</h1>
      </div>

      <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow">
        <div>
          <div>
            {/* Company Introduction */}
            <div className="mb-8">
              <p className="mb-4">
                We are Quantizr, Inc., a Delaware corporation with a principal
                office located at 6300 N Sagewood Dr., Suite H-320, Park City,
                UT 84098.
              </p>
              <p className="mb-4">
                We operate the website{" "}
                <a
                  href="https://www.quantizr.com"
                  className="text-blue-600 hover:underline"
                >
                  https://www.quantizr.com
                </a>
                , including certain related extensions and subdomains
                (collectively, the "Site"), as well as various other related
                products and services. You can contact us by email at{" "}
                <a
                  href="mailto:contact@quantizr.com"
                  className="text-blue-600 hover:underline"
                >
                  contact@quantizr.com
                </a>
                .
              </p>
              <p className="mb-4">
                The Terms of Use provided herein ("Legal Terms") constitute a
                legally binding agreement made between each User, whether
                personally or on behalf of an entity or principal, and Quantizr,
                Inc., concerning Users' access to and use of the Services. You
                may have accessed these Legal Terms digitally through the Site,
                or you may have received a copy attached to an Order Form.
                Either by clicking "I agree" or by executing an attached Order
                Form (if applicable), User agrees that User has read,
                understood, and agreed to be bound by all of these Legal Terms.
                IF USER DOES NOT AGREE WITH ALL OF THESE LEGAL TERMS, THEN USER
                IS EXPRESSLY PROHIBITED FROM USING THE SERVICES AND MUST
                DISCONTINUE USE IMMEDIATELY.
              </p>
              <p className="mb-4">
                We will provide you with prior notice of any scheduled changes
                to the Services you are using. Any amendment to these Legal
                Terms will become effective upon posting the updated Legal Terms
                to the Site, or by notifying you. By continuing to use the
                Services after the effective date of any changes, you agree to
                be bound by the modified terms.
              </p>
              <p className="mb-4">
                The Services are intended for users who are at least 18 years
                old. Persons under the age of 18 are not permitted to use or
                register for the Services.
              </p>
              <p className="mb-4">
                We recommend that you print a copy of these Legal Terms for your
                records.
              </p>
            </div>

            {/* Terms of Use Header */}
            <h1 className="text-3xl font-bold mb-6 text-center">
              TERMS OF USE
            </h1>

            <p className="mb-6">
              These Terms of Use ("Legal Terms") are entered into between
              Quantizr, Inc., a Delaware corporation ("Provider," "we," "us,"
              "our") and you ("User", "you" or "your"), and are made effective
              as of the date of the earlier of User's (1) entering into an Order
              Form or (2) clicking "I agree" ("Effective Date").
            </p>

            <p className="mb-6">
              These Legal Terms, along with any Order Forms and the Quantizr
              Privacy Policy (collectively, the "Agreement"), as updated from
              time to time, constitute the full terms and conditions of User's
              use of the Services as outlined herein.
            </p>

            {/* Section 1: Services */}
            <h2 className="text-2xl font-bold mb-4">1. Services</h2>

            <h3 className="text-xl font-semibold mb-2">
              (a) User Access to the Services.
            </h3>
            <div className="ml-4 mb-4">
              <p className="mb-2">
                (i) Subject to your compliance with these Legal Terms we grant
                you a non‐exclusive, non‐transferable, revocable right to:
              </p>
              <div className="ml-6 mb-2">
                <p>(1) access the Services; and</p>
                <p>
                  (2) download or print a copy of any portion of the Platform
                  Content to which you have properly gained access;
                </p>
                <p>
                  solely for your personal use or internal business purpose.
                </p>
              </div>

              <p className="mb-2">
                (ii) Except as set out in this section or elsewhere in our Legal
                Terms, no part of the Services and no Platform Content or Marks
                may be copied, reproduced, aggregated, republished, uploaded,
                posted, publicly displayed, encoded, translated, transmitted,
                distributed, sold, licensed, or otherwise exploited for any
                commercial purpose whatsoever, without our express prior written
                permission.
              </p>

              <p className="mb-2">
                (iii) If you wish to make any use of the Services, Platform
                Content, or Marks other than as set out in this section or
                elsewhere in our Legal Terms, please address your request to:{" "}
                <a
                  href="mailto:contact@quantizr.com"
                  className="text-blue-600 hover:underline"
                >
                  contact@quantizr.com
                </a>
                . If we ever grant you permission to post, reproduce, or
                publicly display any part of the Services or Platform Content,
                you must identify us as the owners or licensors of the Services,
                Platform Content, or Marks and ensure that any copyright or
                proprietary notice appears or is visible on posting,
                reproducing, or displaying our Platform Content.
              </p>

              <p className="mb-2">
                (iv) We reserve all rights not expressly granted to you in and
                to the Services, Platform Content, and Marks.
              </p>

              <p className="mb-2">
                (v) Any breach of these Intellectual Property Rights will
                constitute a material breach of the Agreement and your right to
                use the Services will terminate immediately.
              </p>
            </div>

            <h3 className="text-xl font-semibold mb-2">
              (b) User Registration.
            </h3>
            <p className="ml-4 mb-4">
              You may be required to register to use the Services. You agree to
              keep your password confidential and will be responsible for all
              use of your account and password. We reserve the right to remove,
              reclaim, or change a username you select if we determine, in our
              sole discretion, that such username is inappropriate, obscene, or
              otherwise objectionable.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (c) Prohibited Activities.
            </h3>
            <div className="ml-4 mb-4">
              <p className="mb-2">
                You may not access or use the Services for any purpose other
                than that for which we make the Services available. The Services
                may not be used in connection with any commercial endeavors
                except those that are specifically endorsed or approved by us.
              </p>

              <p className="mb-2">
                (i) As a User of the Services, you agree not to:
              </p>
              <div className="ml-6">
                <p className="mb-1">
                  (1) Systematically retrieve data or other content from the
                  Services to create or compile, directly or indirectly, a
                  collection, compilation, database, or directory without
                  written permission from us.
                </p>
                <p className="mb-1">
                  (2) Trick, defraud, or mislead us or other users, especially
                  in any attempt to learn sensitive account information such as
                  user passwords.
                </p>
                <p className="mb-1">
                  (3) Circumvent, disable, or otherwise interfere with
                  security‐related features of the Services, including features
                  that prevent or restrict the use or copying of any Platform
                  Content or enforce limitations on the use of the Services
                  and/or the Platform Content contained therein.
                </p>
                <p className="mb-1">
                  (4) Disparage, tarnish, or otherwise harm, in our opinion, us
                  and/or the Services.
                </p>
                <p className="mb-1">
                  (5) Use any information obtained from the Services in order to
                  harass, abuse, or harm another person.
                </p>
                <p className="mb-1">
                  (6) Make improper use of our support services or submit false
                  reports of abuse or misconduct.
                </p>
                <p className="mb-1">
                  (7) Use the Services in a manner inconsistent with any
                  Applicable Laws or regulations.
                </p>
                <p className="mb-1">
                  (8) Engage in unauthorized framing of or linking to the
                  Services.
                </p>
                <p className="mb-1">
                  (9) Upload or transmit (or attempt to upload or to transmit)
                  viruses, Trojan horses, or other material, including excessive
                  use of capital letters and spamming (continuous posting of
                  repetitive text), that interferes with any party's
                  uninterrupted use and enjoyment of the Services or modifies,
                  impairs, disrupts, alters, or interferes with the use,
                  features, functions, operation, or maintenance of the
                  Services.
                </p>
                <p className="mb-1">
                  (10) Engage in any automated use of the system or Services,
                  such as using scripts to send comments or messages, or using
                  any data mining, robots, or similar data gathering and
                  extraction tools.
                </p>
                <p className="mb-1">
                  (11) Delete the copyright or other proprietary rights notice
                  from any Platform Content.
                </p>
                <p className="mb-1">
                  (12) Attempt to impersonate another user or person or use the
                  username of another user.
                </p>
                <p className="mb-1">
                  (13) Upload or transmit (or attempt to upload or to transmit)
                  any material that acts as a passive or active information
                  collection or transmission mechanism, including without
                  limitation, clear graphics interchange formats ("gifs"), 1×1
                  pixels, web bugs, cookies, or other similar devices (sometimes
                  referred to as "spyware" or "passive collection mechanisms" or
                  "pcms").
                </p>
                <p className="mb-1">
                  (14) Interfere with, disrupt, or create an undue burden on the
                  Services or the networks or services connected to the
                  Services.
                </p>
                <p className="mb-1">
                  (15) Harass, annoy, intimidate, or threaten any of our
                  employees or agents engaged in providing any portion of the
                  Services to you.
                </p>
                <p className="mb-1">
                  (16) Attempt to bypass any measures of the Services designed
                  to prevent or restrict access to the Services, or any portion
                  of the Services.
                </p>
                <p className="mb-1">
                  (17) Copy or adapt the Services' software, including but not
                  limited to Flash, PHP, HTML, JavaScript, or other code.
                </p>
                <p className="mb-1">
                  (18) Except as permitted by Applicable Law, decipher,
                  decompile, disassemble, or reverse engineer any of the
                  software comprising or in any way making up a part of the
                  Services.
                </p>
                <p className="mb-1">
                  (19) Except as may be the result of standard search engine or
                  Internet browser usage, use, launch, develop, or distribute
                  any automated system, including without limitation, any
                  spider, robot, cheat utility, scraper, or offline reader that
                  accesses the Services, or use or launch any unauthorized
                  script or other software.
                </p>
                <p className="mb-1">
                  (20) Make any unauthorized use of the Services, including
                  collecting usernames and/or email addresses of users by
                  electronic or other means for the purpose of sending
                  unsolicited email, or creating user accounts by automated
                  means or under false pretenses.
                </p>
                <p className="mb-1">
                  (21) Use the Services as part of any effort to compete with us
                  or otherwise use the Services and/or the Platform Content for
                  any revenue‐generating endeavor or commercial enterprise.
                </p>
                <p className="mb-1">
                  (22) Do or allow anyone else to do the following: (i) reverse
                  engineer, decompile, or attempt to discover any source code or
                  underlying ideas or algorithms of the Services (except to the
                  extent Applicable Laws prohibit this restriction); (ii)
                  provide, sell, transfer, sublicense, lend, distribute, rent,
                  or otherwise allow others to access or use the Services or any
                  outputs derived from the Services (the "Output"), except for
                  internal purposes; (iii) remove any proprietary notices or
                  labels; (iv) copy, modify, or create derivative works of the
                  Services; (v) conduct security or vulnerability tests on,
                  interfere with the operation of, cause performance degradation
                  of, or circumvent access restrictions of the Services; (vi)
                  access accounts, information, data, or portions of the
                  Services to which User does not have explicit authorization;
                  (vii) use the Services to develop a competing service or
                  product; (viii) use the Services with activity prohibited by
                  Applicable Laws; (ix) use the Services to obtain unauthorized
                  access to anyone else's networks or equipment; (x) upload,
                  submit, or otherwise make available to the Services any
                  information, data, documents, or content to which User does
                  not have the proper rights; or (xi) rely upon Outputs for
                  legal, employment, or other high-risk purposes.
                </p>
              </div>
            </div>

            <h3 className="text-xl font-semibold mb-2">
              (d) Third‐Party Websites and Content.
            </h3>
            <p className="ml-4 mb-4">
              The Services may contain (or you may be sent via the Site) links
              to other websites ("Third‐Party Websites") as well as articles,
              photographs, text, graphics, pictures, designs, music, sound,
              video, information, applications, software, and other content or
              items belonging to or originating from third parties ("Third‐Party
              Content"). Such Third‐Party Websites and Third‐Party Content are
              not investigated, monitored, or checked for accuracy,
              appropriateness, or completeness by us, and we are not responsible
              for any Third‐Party Websites accessed through the Services or any
              Third‐Party Content posted on, available through, or installed
              from the Services, including the content, accuracy, offensiveness,
              opinions, reliability, privacy practices, or other policies of or
              contained in the Third‐Party Websites or the Third‐Party Content.
              Inclusion of, linking to, or permitting the use or installation of
              any Third‐Party Websites or any Third‐Party Content does not imply
              approval or endorsement thereof by us. If you decide to leave the
              Services and access the Third‐Party Websites or to use or install
              any Third‐Party Content, you do so at your own risk, and you
              should be aware these Legal Terms no longer govern. You should
              review the applicable terms and policies, including privacy and
              data gathering practices, of any website to which you navigate
              from the Services or relating to any applications you use or
              install from the Services. Any purchases you make through
              Third‐Party Websites will be through other websites and from other
              companies, and we take no responsibility whatsoever in relation to
              such purchases which are exclusively between you and the
              applicable third party. You agree and acknowledge that we do not
              endorse the products or services offered on Third‐Party Websites
              and you shall hold us blameless from any harm caused by your
              purchase of such products or services. Additionally, you shall
              hold us blameless from any losses sustained by you or harm caused
              to you relating to or resulting in any way from any Third‐Party
              Content or any contact with Third‐Party Websites.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (e) Services Management.
            </h3>
            <p className="ml-4 mb-4">
              We reserve the right, but not the obligation, to: (i) monitor the
              Services for violations of these Legal Terms; (ii) take
              appropriate legal action against anyone who, in our sole
              discretion, violates the law or these Legal Terms, including
              without limitation, reporting such user to law enforcement
              authorities; (iii) in our sole discretion and without limitation,
              notice, or liability, to remove from the Services or otherwise
              disable all files and content that are excessive in size or are in
              any way burdensome to our systems; and (iv) otherwise manage the
              Services in a manner designed to protect our rights and property
              and to facilitate the proper functioning of the Services.
            </p>

            <h3 className="text-xl font-semibold mb-2">(f) Privacy Policy.</h3>
            <p className="ml-4 mb-4">
              We care about data privacy and security. Please review our privacy
              policy at{" "}
              <a
                href="https://app.quantizr.com/privacy-policy"
                className="text-blue-600 hover:underline"
              >
                https://app.quantizr.com/privacy-policy
              </a>{" "}
              (the "Quantizr Privacy Policy"). By using the Services, you agree
              to be bound by the Quantizr Privacy Policy, which is incorporated
              into this Agreement. Please be advised the Services are hosted in
              the United States. If you access the Services from any other
              region of the world with laws or other requirements governing
              personal data collection, use, or disclosure that differ from
              Applicable Laws in the United States, then through your continued
              use of the Services, you are transferring your data to the United
              States, and you expressly consent to have your data transferred to
              and processed in the United States.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (g) Modifications and Interruptions.
            </h3>
            <p className="ml-4 mb-4">
              We reserve the right to change, modify, or remove the contents of
              the Services at any time or for any reason at our sole discretion
              without notice. However, we have no obligation to update any
              information on the Services. We will not be liable to you or any
              third party for any modification, price change, suspension, or
              discontinuance of the Services. We cannot guarantee the Services
              will be available at all times. We may experience hardware,
              software, or other problems or need to perform maintenance related
              to the Services, resulting in interruptions, delays, or errors. We
              reserve the right to change, revise, update, suspend, discontinue,
              or otherwise modify the Services at any time or for any reason
              without notice to you. You agree that we have no liability
              whatsoever for any loss, damage, or inconvenience caused by your
              inability to access or use the Services during any downtime or
              discontinuance of the Services. Nothing in these Legal Terms will
              be construed to obligate us to maintain and support the Services
              or to supply any corrections, updates, or releases in connection
              therewith.
            </p>

            <h3 className="text-xl font-semibold mb-2">(h) Data Backups.</h3>
            <p className="ml-4 mb-4">
              We will maintain certain data that you transmit to the Services
              for the purpose of managing the performance of the Services, as
              well as data relating to your use of the Services. Although we
              perform regular routine backups of data, you are solely
              responsible for all data that you transmit to or that relates to
              any activity you have undertaken using the Services. You agree
              that we shall have no liability to you for any loss or corruption
              of any such data, and you hereby waive any right of action against
              us arising from any such loss or corruption of such data.
            </p>

            {/* Section 2: Confidentiality */}
            <h2 className="text-2xl font-bold mb-4">2. Confidentiality</h2>

            <h3 className="text-xl font-semibold mb-2">
              (a) Non-Use and Non-Disclosure.
            </h3>
            <p className="ml-4 mb-4">
              Unless otherwise authorized in the Agreement, Recipient will (i)
              only use Discloser's Confidential Information to fulfill its
              obligations or exercise its rights under this Agreement; and (ii)
              not disclose Discloser's Confidential Information to anyone else.
              In addition, Recipient will protect Discloser's Confidential
              Information using at least the same protections Recipient uses for
              its own similar information but no less than a reasonable standard
              of care.
            </p>

            <h3 className="text-xl font-semibold mb-2">(b) Exclusions.</h3>
            <p className="ml-4 mb-4">
              Confidential Information does not include information that (i)
              Recipient knew without any obligation of confidentiality before
              disclosure by Discloser; (ii) is or becomes publicly known and
              generally available through no fault of Recipient; (iii) Recipient
              receives under no obligation of confidentiality from someone else
              who is authorized to make the disclosure; or (iv) Recipient
              independently developed without use of or reference to Discloser's
              Confidential Information. Feedback does not constitute User's
              Confidential Information. In addition, to the extent Derivative
              Data based upon User's Confidential Information has been
              sufficiently anonymized or modified in a way so as to make it
              unattributable to User, such Derivative Data does not constitute
              Confidential Information.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (c) Required Disclosures.
            </h3>
            <p className="ml-4 mb-4">
              Recipient may disclose Discloser's Confidential Information to the
              extent required by Applicable Laws if, unless prohibited by
              Applicable Laws, Recipient provides the Discloser reasonable
              advance notice of the required disclosure and reasonably
              cooperates, at the Discloser's expense, with the Discloser's
              efforts to obtain confidential treatment for the Confidential
              Information.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (d) Permitted Disclosures.
            </h3>
            <p className="ml-4 mb-4">
              Recipient may disclose Discloser's Confidential Information to
              Recipient's employees, advisors, contractors, vendors, data
              processors, and representatives who each have a need to know the
              Confidential Information, but only if the person or entity is
              bound by confidentiality obligations at least as protective as
              those in this Agreement.
            </p>

            {/* Section 3: Intellectual Property */}
            <h2 className="text-2xl font-bold mb-4">
              3. Intellectual Property
            </h2>

            <h3 className="text-xl font-semibold mb-2">
              (a) User Data Ownership.
            </h3>
            <p className="ml-4 mb-4">
              User owns all Data licensed to Provider under this Agreement;
              Provider's use of User's Data will be governed by this Agreement.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (b) Provider Intellectual Property.
            </h3>
            <p className="ml-4 mb-4">
              Provider is the owner or licensee of all Intellectual Property
              Rights in the Services, including all source code, databases,
              functionality, software, website designs, audio, video, text,
              photographs, and graphics in the Services (collectively, the
              "Platform Content"), as well as the trademarks, service marks, and
              logos contained therein (the "Marks"). Further, Provider
              exclusively owns all rights, title, and interest in and to any
              Derivative Data. User acknowledges that it has no ownership,
              license, or other rights in or to the Derivative Data and agrees
              that Provider may use, reproduce, modify, distribute, and
              otherwise exploit the Derivative Data for any purpose permitted by
              Applicable Laws.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (c) Copyright Infringement.
            </h3>
            <p className="ml-4 mb-4">
              If User believes that any material available on or through the
              Services infringes upon any copyright User owns or controls, User
              will immediately notify Provider using the contact information
              provided below (a "Notification"). Pursuant to Applicable Law,
              User may be held liable for damages if User makes material
              misrepresentations in a Notification.
            </p>

            <h3 className="text-xl font-semibold mb-2">(d) User's Marks.</h3>
            <p className="ml-4 mb-4">
              User hereby grants Provider a limited, non-exclusive,
              non-transferable, revocable license to use User's name, logo, and
              trademarks ("User's Marks") solely for the purpose of identifying
              User as a customer in Provider's marketing materials, press
              releases, or other announcements. Provider will provide User with
              notice of such use and will reasonably comply with any brand
              guidelines that User provides to Provider in writing.
              Additionally, Provider will reasonably cooperate with requests
              from User regarding the manner and scope of such use.
            </p>

            {/* Section 4: Data License */}
            <h2 className="text-2xl font-bold mb-4">4. Data License</h2>

            <h3 className="text-xl font-semibold mb-2">(a) License Grant.</h3>
            <p className="ml-4 mb-4">
              User hereby grants Provider a perpetual, non-exclusive,
              non-sublicensable (except in compliance with Section 4.(b)), and
              non-transferable (except in compliance with Section 12.(i))
              license to use the Data for Provider's internal business purposes,
              including to create Derivative Data. Such license shall survive
              the Term of the Agreement, subject to all confidentiality
              requirements provided in this Agreement and provided that such
              perpetual license shall apply only to the extent such Data is
              being used as part of, or to improve, the Services.
            </p>

            <h3 className="text-xl font-semibold mb-2">(b) Sublicensing.</h3>
            <p className="ml-4 mb-4">
              User hereby grants to Provider the right to grant sublicenses
              (which right shall not include the right to grant further
              sublicenses) under the license rights granted under Section 4.(a)
              to Provider's affiliates and subcontractors, solely as required to
              provide the Services. Provider's right to grant sublicenses under
              this Agreement shall not exceed the scope of rights granted to
              Provider under this Agreement. User acknowledges that Provider is
              not responsible or in any way liable for the acts or omissions of
              any such sublicensees unless such acts constitute a breach by
              Provider of this Agreement.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (c) Use Restrictions.
            </h3>
            <p className="ml-4 mb-4">
              Provider shall only use the Data as permitted under this Agreement
              and shall not disclose, release, distribute, or deliver the Data
              to any third party (except as specifically provided herein or in
              the Quantizr Privacy Policy) without User's prior written consent.
              Any purpose or use not specifically authorized by this Agreement
              is prohibited unless otherwise agreed to by User.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (d) Permissible Uses.
            </h3>
            <p className="ml-4 mb-4">
              Provider may use the Data to further develop and improve the
              Services and may use the Data as necessary (including Provider's
              use of certain third-party services incorporated into the
              Services) in order to provide to User, and other users, the
              Services. User agrees that Provider may use, copy, or modify the
              Data and may create derivative works of the Data (i.e., Derivative
              Data); provided, however, that Data constituting specific dollar
              amounts pertaining to User's pricing, charges, and rates will not
              be included directly in Derivative Data, unless agreed by the
              parties. Provider shall not rent, lease, lend, sell, sublicense,
              assign, distribute, publish, transfer, or otherwise make available
              to the public the Data; provided however, that Provider may
              publish or display a compilation, aggregation, or other summary
              based upon the Derivative Data. Additional permissible uses may be
              identified in the Quantizr Privacy Policy.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (e) Export Regulation.
            </h3>
            <p className="ml-4 mb-4">
              The Data may be subject to US export control laws, including the
              Export Control Reform Act and its associated regulations. Provider
              shall not, directly or indirectly, export, re-export, or release
              the Data to, or make the Data accessible from, any jurisdiction or
              country to which export, re-export, or release is prohibited by
              law, rule, or regulation. Provider shall comply with all
              applicable federal laws, regulations, and rules, and complete all
              required undertakings (including obtaining any necessary export
              license or other governmental approval), prior to exporting,
              re-exporting, releasing, or otherwise making the Data available
              outside the US.
            </p>

            {/* Section 5: Representations and Warranties; Disclaimers */}
            <h2 className="text-2xl font-bold mb-4">
              5. Representations and Warranties; Disclaimers
            </h2>

            <h3 className="text-xl font-semibold mb-2">
              (a) User Representations and Warranties.
            </h3>
            <div className="ml-4 mb-4">
              <p className="mb-2">
                User represents, warrants, and covenants to Provider that:
              </p>
              <div className="ml-6">
                <p className="mb-1">
                  (i) All Data that User submits, including registration
                  information, will be accurate, current, and complete.
                </p>
                <p className="mb-1">
                  (ii) User has legal capacity and agrees to comply with these
                  Legal Terms.
                </p>
                <p className="mb-1">
                  (iii) User will not access the Services through automated or
                  non-human means (i.e., through a bot, script, or otherwise).
                </p>
                <p className="mb-1">
                  (iv) User will not use the Services for any illegal or
                  unauthorized purpose.
                </p>
                <p className="mb-1">
                  (v) User's use of the Services will not violate any Applicable
                  Law or regulation.
                </p>
                <p className="mb-1">
                  (vi) User either: is not an entity based in the United Kingdom
                  or European Union, or will notify Provider if it is an entity
                  based in the United Kingdom or European Union prior to using
                  the Services.
                </p>
                <p className="mb-1">
                  (vii) As of the Effective Date, and at any subsequent time
                  that User provides Data to us, User has all necessary rights
                  and licenses required to provide the Data for use as
                  implicated by the Agreement, including the authority to grant
                  the licenses and transfer rights pursuant to this Agreement.
                </p>
                <p className="mb-1">
                  (viii) Disclosure of the Data complies with all laws,
                  including any requirements for valid, informed consent or
                  authority to share such materials.
                </p>
                <p className="mb-1">
                  (ix) User's use of the Data pursuant to the terms of the
                  Agreement will not result in the infringement of any
                  third-party intellectual property or privacy rights.
                </p>
                <p className="mb-1">
                  (x) User will promptly notify Provider of any Data that does
                  not comply with the above requirements.
                </p>
              </div>
            </div>

            <h3 className="text-xl font-semibold mb-2">(b) DISCLAIMERS.</h3>
            <p className="ml-4 mb-4 uppercase">
              THE SERVICES ARE PROVIDED ON AN AS‐IS AND AS‐AVAILABLE BASIS. YOU
              AGREE THAT YOUR USE OF THE SERVICES WILL BE AT YOUR SOLE RISK. TO
              THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES,
              EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICES AND YOUR USE
              THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND
              NON‐INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT
              THE ACCURACY OR COMPLETENESS OF THE SERVICES' CONTENT OR THE
              CONTENT OF ANY WEBSITES OR APPLICATIONS LINKED TO THE SERVICES AND
              WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (i) ERRORS,
              MISTAKES, OR INACCURACIES OF PLATFORM CONTENT, OUTPUTS, AND
              MATERIALS, (ii) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE
              WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE SERVICES,
              (iii) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS
              AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL
              INFORMATION STORED THEREIN, (iv) ANY INTERRUPTION OR CESSATION OF
              TRANSMISSION TO OR FROM THE SERVICES, (v) ANY BUGS, VIRUSES,
              TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH
              THE SERVICES BY ANY THIRD PARTY, AND/OR (vi) ANY ERRORS OR
              OMISSIONS IN ANY PLATFORM CONTENT AND MATERIALS OR FOR ANY LOSS OR
              DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT
              POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SERVICES.
              WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY
              FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY
              THROUGH THE SERVICES, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR
              MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING,
              AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR
              MONITORING ANY TRANSACTION BETWEEN YOU AND ANY THIRD‐PARTY
              PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF A
              PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU
              SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE
              APPROPRIATE.
            </p>
            <p className="ml-4 mb-4">
              These disclaimers apply to the maximum extent permitted by
              Applicable Laws.
            </p>

            {/* Section 6: Fees and Payment */}
            <h2 className="text-2xl font-bold mb-4">6. Fees and Payment</h2>

            <h3 className="text-xl font-semibold mb-2">
              (a) Billing and Renewal.
            </h3>
            <p className="ml-4 mb-4">
              All fees are as set forth on the Site or in one or more Order
              Forms. Your subscription(s) will continue and automatically renew
              unless canceled. You consent to our charging your payment method
              on a recurring basis without requiring your prior approval for
              each recurring charge, until such time as you cancel the
              applicable subscription. The length of your billing cycle will
              depend on the type of subscription plan you choose when you
              subscribe to the Services, either through the Site or as set forth
              in the relevant Order Form.
            </p>

            <h3 className="text-xl font-semibold mb-2">(b) Cancellation.</h3>
            <p className="ml-4 mb-4">
              You can cancel your subscription at any time by contacting us
              using the contact information provided below. Your cancellation
              will take effect at the end of the then-current paid term. If you
              have any questions or are unsatisfied with the Services, please
              email us at{" "}
              <a
                href="mailto:contact@quantizr.com"
                className="text-blue-600 hover:underline"
              >
                contact@quantizr.com
              </a>
              .
            </p>

            <h3 className="text-xl font-semibold mb-2">(c) Fee Changes.</h3>
            <p className="ml-4 mb-4">
              We may, from time to time, make changes to the fees and will
              communicate any price changes to you in accordance with Applicable
              Law.
            </p>

            <h3 className="text-xl font-semibold mb-2">(d) Payment.</h3>
            <div className="ml-4 mb-4">
              <p className="mb-2">
                Provider accepts the following forms of payment:
              </p>
              <div className="ml-6">
                <p className="mb-1">(i) Visa</p>
                <p className="mb-1">(ii) Mastercard</p>
                <p className="mb-1">(iii) American Express</p>
                <p className="mb-1">
                  (iv) An alternate payment method (e.g., ACH or Wire) as may be
                  agreed upon in an Order Form
                </p>
              </div>
               <p className="mb-2">
                User agrees to provide current, complete, and accurate purchase
                and account information for all purchases made via the Services.
                User further agrees to promptly update account and payment
                information, including email address, payment method, and payment
                card expiration date, so that Provider can complete the
                transactions and contact User as needed. Sales tax will be added
                to the price of purchases as deemed required by Provider.
                Provider may change prices at any time, subject to any
                limitations in a relevant Order Form. All payments shall be in
                US dollars.
              </p>
              <p className="mb-2">
                User agrees to pay all charges at the prices then in effect for
                User's purchases and any applicable shipping fees, and User
                authorizes us to charge User's chosen payment provider for any
                such amounts upon placing your order. Provider reserves the
                right to correct any errors or mistakes in pricing, even if
                Provider has already requested or received payment.
              </p>
              <p className="mb-2">
                Provider reserves the right to refuse any order placed through
                the Site or via an Order Form. Provider may, in Provider's sole
                discretion, limit or cancel quantities purchased per person, per
                household, or per order. These restrictions may include orders
                placed by or under the same customer account, the same payment
                method, and/or orders that use the same billing or shipping
                address. Provider reserves the right to limit or prohibit orders
                that, in Provider's sole judgment, appear to be placed by
                dealers, resellers, or distributors.
              </p>
            </div>

            {/* Section 7: Compliance */}
            <h2 className="text-2xl font-bold mb-4">7. Compliance</h2>
            <p className="mb-4">
              The information provided when using the Services is not intended
              for distribution to or use by any person or entity in any
              jurisdiction or country where such distribution or use would be
              contrary to law or regulation or which would subject us to any
              registration requirement within such jurisdiction or country.
              Accordingly, those persons who choose to access the Services from
              other locations do so on their own initiative and are solely
              responsible for compliance with local laws, if and to the extent
              local laws are applicable.
            </p>
            <p className="mb-4">
              The Services are not tailored to comply with industry‐specific
              regulations (Health Insurance Portability and Accountability Act
              (HIPAA), Federal Information Security Management Act (FISMA),
              etc.), so if your interactions would be subjected to such laws,
              you may not use the Services. You may not use the Services in a
              way that would violate the Gramm‐Leach‐Bliley Act (GLBA).
            </p>

            {/* Section 8: Limitations of Liability */}
            <h2 className="text-2xl font-bold mb-4">
              8. Limitations of Liability
            </h2>
            <p className="mb-4 uppercase">
              EXCEPT AS EXPRESSLY OTHERWISE PROVIDED, IN NO EVENT WILL EITHER
              PARTY BE LIABLE UNDER OR IN CONNECTION WITH THIS AGREEMENT UNDER
              ANY LEGAL OR EQUITABLE THEORY, INCLUDING BREACH OF CONTRACT, TORT
              (INCLUDING NEGLIGENCE), STRICT LIABILITY, AND OTHERWISE, FOR ANY
              CONSEQUENTIAL, INCIDENTAL, INDIRECT, EXEMPLARY, SPECIAL, ENHANCED,
              OR PUNITIVE DAMAGES REGARDLESS OF WHETHER EITHER PARTY WAS ADVISED
              OF THE POSSIBILITY OF SUCH LOSSES OR DAMAGES OR SUCH LOSSES OR
              DAMAGES WERE OTHERWISE FORESEEABLE. IN NO EVENT WILL THE AGGREGATE
              LIABILITY OF EITHER PARTY ARISING OUT OF OR RELATED TO THIS
              AGREEMENT, UNDER ANY LEGAL OR EQUITABLE THEORY, INCLUDING BREACH
              OF CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, AND
              OTHERWISE, EXCEED THE TOTAL AMOUNTS PAID AND AMOUNTS ACCRUED BUT
              NOT YET PAID TO PROVIDER IN THE 12-MONTH PERIOD PRECEDING THE
              EVENT GIVING RISE TO THE CLAIM (THE "GENERAL DAMAGES CAP"). The
              exclusions and limitations in this Section 8 do not apply to
              claims pursuant to Section 3 (Intellectual Property) or Section 9
              (Indemnities).
            </p>
            <p className="mb-4 uppercase">
              IN NO EVENT WILL PROVIDER BE LIABLE UNDER OR IN CONNECTION WITH
              THIS AGREEMENT FOR (1) INFRINGEMENT CLAIMS ARISING FROM OUTPUTS
              GENERATED BY AI TOOLS, INCLUDING GENERATIVE AI FEATURES; (2)
              INACCURACIES IN THE OUTPUTS THAT RESULT FROM USER'S PROVISION OF
              INACCURATE, INCOMPLETE, OR DEFECTIVE DATA; (3) USER'S RELIANCE ON
              ANY OUTPUT; (4) AVAILABILITY OF THE PRODUCT OR THE DATA MADE
              AVAILABLE THROUGH THE PRODUCT; AND (5) INDIRECT, INCIDENTAL, OR
              CONSEQUENTIAL DAMAGES ARISING FROM OR RELATED TO ANY DATA PRIVACY
              BREACHES UNLESS SUCH BREACHES ARE THE RESULT OF PROVIDER'S GROSS
              NEGLIGENCE OR WILLFUL MISCONDUCT.
            </p>

            {/* Section 9: Indemnities */}
            <h2 className="text-2xl font-bold mb-4">9. Indemnities</h2>
            <p className="mb-4">
              User will defend, indemnify, and hold harmless Provider, its
              affiliates, and their respective employees, officers, and
              directors from and against any and all damages, liabilities,
              penalties, fines, costs, and expenses (including reasonable
              attorneys' fees) arising out of or in any way related to any
              third-party claim resulting from: (i) User's breach of the
              warranties provided in Section 2, including claims that User's use
              of the Services constitutes an infringement or misappropriation of
              a third party's intellectual property or privacy rights; (ii)
              User's failure to comply with Applicable Laws; (iii) User's use of
              the Services; (iv) User's breach of this Agreement; or (v) any
              overt harmful act toward any other user of the Services with whom
              User connected via the Services. User's indemnification
              obligations under this Section 9 shall not apply to the extent the
              third-party claim is caused by Provider's fraud, gross negligence,
              willful misconduct, or breach of this Agreement.
            </p>

            {/* Section 10: Term & Termination */}
            <h2 className="text-2xl font-bold mb-4">10. Term & Termination</h2>

            <h3 className="text-xl font-semibold mb-2">(a) Agreement Term.</h3>
            <p className="ml-4 mb-4">
              This Agreement will start on the Effective Date and continue until
              terminated by either party as provided herein or in an Order Form
              (the "Term").
            </p>

            <p className="mb-4 uppercase">
              These Legal Terms shall remain in full force and effect while you
              use the Services. WITHOUT LIMITING ANY OTHER PROVISION OF THESE
              LEGAL TERMS, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND
              WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE
              SERVICES (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON
              FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR
              BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN
              THESE LEGAL TERMS OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY
              TERMINATE YOUR USE OR PARTICIPATION IN THE SERVICES, WITHOUT
              WARNING, IN OUR SOLE DISCRETION.
            </p>

            <p className="mb-4">
              Provider reserves the right to suspend User's access to the
              Services in the event of User's breach of the Agreement, or if
              User's use of the Services results in potential threats to the
              security or performance of the Services. During such suspension,
              User may not have access to the materials provided as part of the
              Services, and Provider shall not be responsible for any losses or
              failures resulting from such suspension. If we terminate or
              suspend your account for any reason, you are prohibited from
              registering and creating a new account, even if you may be acting
              on behalf of a third party. In addition to terminating or
              suspending your account, we reserve the right to take appropriate
              legal action, including without limitation pursuing civil,
              criminal, and injunctive redress.
            </p>

{/* Section 11: Survival */}
            <h2 className="text-2xl font-bold mb-4">11. Survival</h2>

            <h3 className="text-xl font-semibold mb-2">
              (a) Surviving Terms.
            </h3>
            <p className="ml-4 mb-4">
              The Quantizr Privacy Policy and the following sections of these
              Legal Terms will survive expiration or termination of the
              Agreement: Section 2 (Confidentiality), Section 3 (Intellectual
              Property), Section 5 (Representations and Warranties;
              Disclaimers), Section 11(b) (General Terms), Section 8 (Survival),
              Section 13 (Definitions).
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (b) Retained Confidential Information.
            </h3>
            <p className="ml-4 mb-4">
              Each Recipient may retain Discloser's Confidential Information in
              accordance with its standard backup or record retention policies
              maintained in the ordinary course of business or as required by
              Applicable Laws, in which case Section 2 (Confidentiality) will
              continue to apply to retained Confidential Information.
            </p>

            <h3 className="text-xl font-semibold mb-2">(c) Retained Data.</h3>
            <p className="ml-4 mb-4">
              User acknowledges that to the extent that any of User's Data has
              been incorporated into the Services in a manner that makes it
              anonymous, unidentifiable, or unexcisable, including being used to
              improve any artificial intelligence, machine learning, search,
              benchmarking, or other functionality or tool of the Services, that
              such Data may not be fully removed or deleted upon Termination.
            </p>

                        {/* Section 12: General Terms */}
            <h2 className="text-2xl font-bold mb-4">12. General Terms</h2>

            <h3 className="text-xl font-semibold mb-2">
              (a) Feedback Submissions.
            </h3>
            <p className="ml-4 mb-4">
              By directly sending us any question, comment, suggestion, idea,
              feedback, or other information about the Services ("Feedback"),
              you agree to assign to us all Intellectual Property Rights in such
              Feedback. You agree that we shall own the Feedback and be entitled
              to its unrestricted use and dissemination for any lawful purpose,
              commercial or otherwise, without acknowledgment or compensation to
              you.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (b) Entire Agreement.
            </h3>
            <p className="ml-4 mb-4">
              These Legal Terms and any policies or operating rules posted by us
              on the Services or in respect to the Services constitute the
              entire agreement and understanding between you and us. Our failure
              to exercise or enforce any right or provision of these Legal Terms
              shall not operate as a waiver of such right or provision. These
              Legal Terms operate to the fullest extent permissible by law. We
              may assign any or all of our rights and obligations to others at
              any time. We shall not be responsible or liable for any loss,
              damage, delay, or failure to act caused by any cause beyond our
              reasonable control. If any provision or part of a provision of
              these Legal Terms is determined to be unlawful, void, or
              unenforceable, that provision or part of the provision is deemed
              severable from these Legal Terms and does not affect the validity
              and enforceability of any remaining provisions. There is no joint
              venture, partnership, employment or agency relationship created
              between you and us as a result of these Legal Terms or use of the
              Services. You agree that these Legal Terms will not be construed
              against us by virtue of having drafted them. You hereby waive any
              and all defenses you may have based on the electronic form of
              these Legal Terms and the lack of signing by the parties hereto to
              execute these Legal Terms.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (c) Superiority of Terms.
            </h3>
            <p className="ml-4 mb-4">
              The relationship between the parties is also governed by the
              Quantizr Privacy Policy which is incorporated herein by reference,
              and any Order Form the parties enter into. In the event of a
              direct conflict between these Legal Terms, the Quantizr Privacy
              Policy, and an Order Form, then the terms of the Order Form will
              control first, followed by these Legal Terms, and then the
              Quantizr Privacy Policy.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (d) Modifications, Severability, and Waiver.
            </h3>
            <p className="ml-4 mb-4">
              Except as provided in the preamble to these Legal Terms, any
              waiver, modification, or change to the Agreement must be in
              writing and signed or electronically accepted by each party. If
              any term of this Agreement is determined to be invalid or
              unenforceable by a relevant court or governing body, the remaining
              terms of this Agreement will remain in full force and effect. The
              failure of a party to enforce a term or to exercise an option or
              right in this Agreement will not constitute a waiver by that party
              of the term, option, or right.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (e) Governing Law and Jurisdiction.
            </h3>
            <p className="ml-4 mb-4">
              This Agreement is governed by and construed in accordance with the
              internal laws of the State of Utah without giving effect to any
              choice or conflict of law provision or rule that would require or
              permit the application of the laws of any jurisdiction other than
              those of the State of Utah. Any legal suit, action, or proceeding
              arising out of this Agreement or the licenses granted hereunder
              will be instituted exclusively in the federal courts of the United
              States or the courts of the State of Utah, in each case located in
              the city of Salt Lake City and County of Salt Lake, and each party
              irrevocably submits to the exclusive jurisdiction of such courts
              in any such suit, action, or proceeding.
            </p>

            <h3 className="text-xl font-semibold mb-2">(f) Force Majeure.</h3>
            <p className="ml-4 mb-4">
              Except for payment obligations, neither party will be liable for
              any delay or failure to perform any obligation under this
              Agreement where the delay or failure results from any cause beyond
              its reasonable control, including acts of God, labor disputes or
              other industrial disturbances, electrical or power outage,
              utilities or telecommunications failures, earthquake, storms or
              other elements of nature, blockages, embargoes, riots, acts or
              orders of government, acts of terrorism, or war.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (g) Injunctive Relief.
            </h3>
            <p className="ml-4 mb-4">
              Despite Section 12(e) (Governing Law and Jurisdiction), a breach
              of Section 2 (Confidentiality) or the violation of a party's
              Intellectual Property Rights may cause irreparable harm for which
              monetary damages cannot provide adequate compensation. As a result,
              upon the actual or threatened breach of Section 2
              (Confidentiality) or violation of a party's Intellectual Property
              Rights, the non-breaching or non-violating party may seek
              appropriate equitable relief, including an injunction, in any
              court of competent jurisdiction without the need to post a bond
              and without limiting its other rights or remedies.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (h) Non-Exhaustive Remedies.
            </h3>
            <p className="ml-4 mb-4">
              Except where the Agreement provides for an exclusive remedy,
              seeking or exercising a remedy does not limit the other rights or
              remedies available to a party.
            </p>

            <h3 className="text-xl font-semibold mb-2">(i) Assignment.</h3>
            <p className="ml-4 mb-4">
              User may not assign any rights or obligations under this Agreement
              without the prior written consent of Provider. This Agreement will
              be binding upon and inure to the benefit of the parties and their
              permitted successors and assigns.
            </p>

            <h3 className="text-xl font-semibold mb-2">(j) Notices.</h3>
            <p className="ml-4 mb-4">
              Any notice, request, or approval about the Agreement must be in
              writing and sent to the Notice Address. Notices will be deemed
              given (i) upon confirmed delivery if by email, registered or
              certified mail, or personal delivery; or (ii) two days after
              mailing if by overnight commercial delivery.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (k) Independent Contractors.
            </h3>
            <p className="ml-4 mb-4">
              The parties are independent contractors, not agents, partners, or
              joint venturers. Neither party is authorized to bind the other to
              any liability or obligation.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (l) No Third-Party Beneficiary.
            </h3>
            <p className="ml-4 mb-4">
              There are no third-party beneficiaries of this Agreement.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (m) Titles and Interpretation.
            </h3>
            <p className="ml-4 mb-4">
              Section titles are for convenience and reference only. All uses of
              "including" and similar phrases are non-exhaustive and without
              limitation. The United Nations Convention for the International
              Sale of Goods and the Uniform Computer Information Transaction Act
              do not apply to this Agreement.
            </p>

            <h3 className="text-xl font-semibold mb-2">(n) Publicity.</h3>
            <p className="ml-4 mb-4">
              During the Term, Provider may identify User as a customer in its
              marketing materials, press releases, or other announcements,
              subject to the restrictions provided in Section 3(d).
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (o) Electronic Communications, Transactions, and Signatures.
            </h3>
            <p className="ml-4 mb-4">
              Visiting the Services, sending us emails, and completing online
              forms constitute electronic communications. You consent to receive
              electronic communications, and you agree that all agreements,
              notices, disclosures, and other communications we provide to you
              electronically, via email and on the Services, satisfy any legal
              requirement that such communication be in writing.{" "}
              <span className="uppercase">
                YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES,
                CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY
                OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR
                COMPLETED BY US OR VIA THE SERVICES.
              </span>{" "}
              You hereby waive any rights or requirements under any statutes,
              regulations, rules, ordinances, or other laws in any jurisdiction
              which require an original signature or delivery or retention of
              non‐electronic records, or to payments or the granting of credits
              by any means other than electronic means.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (p) Dispute Resolution.
            </h3>

            <h4 className="text-lg font-semibold mb-2 ml-4">
              (i) Informal Negotiations.
            </h4>
            <p className="ml-8 mb-4">
              To expedite resolution and control the cost of any dispute,
              controversy, or claim related to these Legal Terms (each a
              "Dispute" and collectively, the "Disputes") brought by either you
              or us (individually, a "Party" and collectively, the "Parties"),
              the Parties agree to first attempt to negotiate any Dispute
              (except those Disputes expressly provided below) informally for at
              least thirty (30) days before initiating arbitration. Such
              informal negotiations commence upon written notice from one Party
              to the other Party.
            </p>

            <h4 className="text-lg font-semibold mb-2 ml-4">
              (ii) Binding Arbitration.
            </h4>
            <p className="ml-8 mb-4">
              If the Parties are unable to resolve a Dispute through informal
              negotiations, the Dispute (except those Disputes expressly
              excluded below) will be finally and exclusively resolved by
              binding arbitration.{" "}
              <span className="uppercase">
                BY AGREEING TO THIS PROVISION, YOU GIVE UP YOUR RIGHT TO SUE IN
                COURT AND HAVE A JURY TRIAL.
              </span>{" "}
              The arbitration shall be commenced and conducted under the
              Commercial Arbitration Rules of the American Arbitration
              Association ("AAA") and, where appropriate, the AAA's
              Supplementary Procedures for Consumer Related Disputes ("AAA
              Consumer Rules"), both of which are available at the American
              Arbitration Association (AAA) website. Your arbitration fees and
              your share of arbitrator compensation shall be governed by the AAA
              Consumer Rules and, where appropriate, limited by the AAA Consumer
              Rules. The arbitration may be conducted in person, through the
              submission of documents, by phone, or online. The arbitrator will
              make a decision in writing, but need not provide a statement of
              reasons unless requested by either Party. The arbitrator must
              follow Applicable Law, and any award may be challenged if the
              arbitrator fails to do so. Except where otherwise required by the
              applicable AAA rules or Applicable law, the arbitration will take
              place in Salt Lake City, Utah. Except as otherwise provided
              herein, the Parties may litigate in court to compel arbitration,
              stay proceedings pending arbitration, or to confirm, modify,
              vacate, or enter judgment on the award entered by the arbitrator.
            </p>

            <p className="ml-8 mb-4">
              If for any reason, a Dispute proceeds in court rather than
              arbitration, the Dispute shall be commenced or prosecuted in the
              state and federal courts located in Salt Lake City, Utah, and the
              Parties hereby consent to, and waive all defenses of lack of
              personal jurisdiction, and forum non conveniens with respect to
              venue and jurisdiction in such state and federal courts.
              Application of the United Nations Convention on Contracts for the
              International Sale of Goods and the Uniform Computer Information
              Transaction Act (UCITA) are excluded from these Legal Terms.
            </p>

            <p className="ml-8 mb-4">
              In no event shall any Dispute brought by either Party related in
              any way to the Services be commenced more than one (1) years after
              the cause of action arose. If this provision is found to be
              illegal or unenforceable, then neither Party will elect to
              arbitrate any Dispute falling within that portion of this
              provision found to be illegal or unenforceable and such Dispute
              shall be decided by a court of competent jurisdiction within the
              courts listed for jurisdiction above, and the Parties agree to
              submit to the personal jurisdiction of that court.
            </p>

            <h4 className="text-lg font-semibold mb-2 ml-4">
              (iii) Restrictions.
            </h4>
            <p className="ml-8 mb-4">
              The Parties agree that any arbitration shall be limited to the
              Dispute between the Parties individually. To the full extent
              permitted by law, (1) no arbitration shall be joined with any
              other proceeding; (2) there is no right or authority for any
              Dispute to be arbitrated on a class‐action basis or to utilize
              class action procedures; and (3) there is no right or authority
              for any Dispute to be brought in a purported representative
              capacity on behalf of the general public or any other persons.
            </p>

            <h4 className="text-lg font-semibold mb-2 ml-4">
              (iv) Exceptions to Informal Negotiations and Arbitration.
            </h4>
            <p className="ml-8 mb-4">
              The Parties agree that the following Disputes are not subject to
              the above provisions concerning informal negotiations binding
              arbitration: (1) any Disputes seeking to enforce or protect, or
              concerning the validity of, any of the Intellectual Property
              Rights of a Party; (2) any Dispute related to, or arising from,
              allegations of theft, piracy, invasion of privacy, or unauthorized
              use; and (3) any claim for injunctive relief. If this provision
              is found to be illegal or unenforceable, then neither Party will
              elect to arbitrate any Dispute falling within that portion of this
              provision found to be illegal or unenforceable and such Dispute
              shall be decided by a court of competent jurisdiction within the
              courts listed for jurisdiction above, and the Parties agree to
              submit to the personal jurisdiction of that court.
            </p>

            <h3 className="text-xl font-semibold mb-2">
              (q) California Users and Residents.
            </h3>
            <p className="ml-4 mb-4">
              If any complaint with us is not satisfactorily resolved, you can
              contact the Complaint Assistance Unit of the Division of Consumer
              Services of the California Department of Consumer Affairs in
              writing at 1625 North Market Blvd., Suite N 112, Sacramento,
              California 95834 or by telephone at (800) 952‐5210 or (916)
              445‐1254.
            </p>

            <h3 className="text-xl font-semibold mb-2">(r) Corrections.</h3>
            <p className="ml-4 mb-4">
              There may be information on the Services that contains
              typographical errors, inaccuracies, or omissions, including
              descriptions, pricing, availability, and various other
              information. We reserve the right to correct any errors,
              inaccuracies, or omissions and to change or update the information
              on the Services at any time, without prior notice.
            </p>

            <h3 className="text-xl font-semibold mb-2">(s) Contact.</h3>
            <p className="ml-4 mb-4">
              In order to resolve a complaint regarding the Services or to
              receive further information regarding use of the Services, please
              contact us at{" "}
              <a
                href="mailto:contact@quantizr.com"
                className="text-blue-600 hover:underline"
              >
                contact@quantizr.com
              </a>
              .
            </p>

            {/* Section 13: Definitions */}
            <h2 className="text-2xl font-bold mb-4">13. Definitions</h2>

            <div className="ml-4 mb-4">
              <p className="mb-4">
                <strong>"Applicable Laws"</strong> means the laws, rules,
                regulations, court orders, and other binding requirements of a
                relevant government authority that apply to or govern Provider
                or User.
              </p>

              <p className="mb-4">
                <strong>"Confidential Information"</strong> means information in
                any form disclosed by or on behalf of a Discloser, including
                before the Effective Date, to a Recipient in connection with
                this Agreement that (i) the Discloser identifies as
                "confidential", "proprietary", or the like; or (ii) should be
                reasonably understood as confidential or proprietary due to its
                nature and the circumstances of its disclosure. Confidential
                Information includes the existence of this Agreement. Provider's
                Confidential Information includes non-public information about
                the Services.
              </p>

              <p className="mb-4">
                <strong>"Data"</strong> means any information, content, or
                materials, in any form or medium, that are uploaded, submitted,
                or otherwise provided by User to Provider, including text,
                images, files, and metadata.
              </p>

              <p className="mb-4">
                <strong>"Derivative Data"</strong> means any copy, modification,
                or inference created by Provider based upon the Data that has
                been processed to remove or obscure any personally identifiable
                information (PII) or other identifiers, ensuring that the
                resulting copy, modification, or inference cannot be reasonably
                linked to any specific User, individual, or entity, either alone
                or in combination with other data that is accessible by a user
                through the Services.
              </p>

              <p className="mb-4">
                <strong>"Discloser"</strong> means a party to this Agreement
                when the party is providing or disclosing Confidential
                Information to the other party.
              </p>

              <p className="mb-4">
                <strong>"Intellectual Property Rights"</strong> means all
                rights, title, and interest in and to any and all intellectual
                property, including but not limited to: patents, trademarks,
                copyrights, trade secrets, software, database rights, industrial
                designs, rights of publicity and privacy, domain names, and any
                other proprietary rights relating to intangible property. This
                includes all such rights whether registered or unregistered,
                applications for the same, and the right to register any such
                rights, as well as all renewals, extensions, continuations,
                divisionals, reissues, and reversions thereof, in any
                jurisdiction worldwide. It also encompasses all rights to sue
                for past, present, and future infringement or misappropriation
                of any of these rights.
              </p>

              <p className="mb-4">
                <strong>"Notice Address"</strong> means:
                <br />
                For Provider:{" "}
                <a
                  href="mailto:contact@quantizr.com"
                  className="text-blue-600 hover:underline"
                >
                  contact@quantizr.com
                </a>{" "}
                cc:{" "}
                <a
                  href="mailto:tim@quantizr.com"
                  className="text-blue-600 hover:underline"
                >
                  tim@quantizr.com
                </a>
                <br />
                For User: the contact information provided by User at signup
                (e.g., email address) or User's contact information listed on an
                Order Form.
              </p>

              <p className="mb-4">
                <strong>"Order Form"</strong> means an order form provided to
                User by Provider that references these Legal Terms and is
                executed by both Provider and User.
              </p>

              <p className="mb-4">
                <strong>"Recipient"</strong> means a party to this Agreement
                when the party receives Confidential Information from the other
                party.
              </p>

              <p className="mb-4">
                <strong>"Services"</strong> means the product or services
                described in an Order Form or on the Site as may be updated from
                time to time, including the online platform known as "Quantizr"
                which provides business process management and business
                intelligence services to users in the entertainment industry.
              </p>

              <p className="mb-4">
                Capitalized terms not defined in this Section are defined inline
                in the Agreement.
              </p>
            </div>


          </div>
        </div>
      </div>
    </div>
  );
}
